export default {
  ConsultantModel: function() {
    return {
      id: '',
      user_id: '',
      nif: '',
      address: '',
      city: '',
      cp: '',
      province: '',
      region: '',
      country: '',
      phone: '',
      description: '',
      metas: [],
      user: {
        name: '',
        email: '',
        password: '',
      },
      meta_data: [],
      customers: [],
      name: '',
      roles: [],
      categories: [],
    };
  },
};
